// extracted by mini-css-extract-plugin
module.exports = {"logosContainer":"styles_logosContainer__djrL0"};